"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:title": "Sjekkliste",
  "ui:layout": "section",
  "ui:options": {
    "collapsible": true,
    "spacing": 0,
    "sortable": true
  },
  "ui:preview": {
    "select": {
      "description": "description"
    },

    prepare({
      formData
    }) {
      let description;

      if (formData && formData.length === 1) {
        description = "1 punkt";
      } else if (formData && formData.length) {
        description = formData.length + " punkter";
      }

      return {
        description: description || "Ingen punkter"
      };
    }

  },
  "ui:options": {
    "collapsible": true
  },
  "ui:buttons": [{
    "icon": "add",
    "label": "Legg til"
  }],
  "items": {
    "ui:field": "primusChecklistItem",
    "ui:layout": "module",
    "ui:preview": {
      "select": {
        "icon": "icon"
      },

      prepare({
        formData
      }) {
        let icon;

        if (formData && formData.checked) {
          icon = "check_box";
        } else {
          icon = "check_box_outline_blank";
        }

        return {
          icon: icon
        };
      }

    },
    "ui:buttons": [{
      "type": "save",
      "icon": "check",
      "label": "Lagre og lukk"
    }],
    "ui:grid": true,
    "ui:editable": true,
    "ui:fieldset": ["title", "checked"],
    "title": {
      "ui:title": "Tittel"
    },
    "description": {
      "ui:title": "Beskrivelse",
      "ui:widget": "textarea"
    },
    "checked": {
      "ui:title": "Marker som utført"
    }
  }
};
exports.default = _default;
module.exports = exports.default;